import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { slideToggle } from './../../composables/slideToggle.js';
import { Icon } from '@iconify/react';
import { AppSettings } from './../../config/app-settings.js';
import PerfectScrollbar from 'react-perfect-scrollbar';

function Header() {
	const { appThemePanelToggled, setAppThemePanelToggled } = useContext(AppSettings);
	const userData = {
		img: '/quantum-react/assets/img/user/profile.jpg',
		name: 'USERNAME@GMAIL.COM'
	};
	const chatData = [
		{ msg: ['Hey, I\'m testing out group messaging.'], name: 'Roberto Lambert', img: '/quantum-react/assets/img/user/user-2.jpg' }, 
		{ msg: ['Cool'], reply: true, time: 'Read 16:26' }, 
		{ date: 'Today 14:21' }, 
		{ msg: ['Awesome! What\'s new?'], name: 'Rick Powell', img: '/quantum-react/assets/img/user/user-3.jpg' }, 
		{ msg: [
				'Not much, It\'s got a new look, contact pics show up in group messaging, some other small stuff.',
				'How\'s crusty old iOS 6 treating you?'
			], name: 'Roberto Lambert', img: '/quantum-react/assets/img/user/user-2.jpg'
		},
		{ msg: ['Sucks'], reply: true, time: 'Read 16:30' }
	];
	const calendarData = [{ 
		date: 'TODAY, NOV 4',
		list: [
			{ time_start: '09:00', time_end: '12:00', color: 'bg-success', title: 'Meeting with HR', desc: ['Conference Room'] },
			{ time_start: '20:00', time_end: '23:00', color: 'bg-primary', title: 'Dinner with Richard', desc: ['Tom\'s Too Restaurant'], 
				contact: [{
					name: 'Richard Leong',
					img: '/quantum-react/assets/img/user/user-3.jpg',
					link: '#'
				}]
			},
		]
	}, { 
		date: 'TOMORROW, NOV 5',
		list: [
			{ time_start: 'All day', color: 'bg-gray-300', title: 'Terry Birthday' },
			{ time_start: '08:00', color: 'bg-gray-300', title: 'Meeting' },
			{ time_start: '00:00', time_end: '00:30', color: 'bg-gray-300', title: 'Server Maintenance', desc: ['Data Centre'] }
		]
	}];
	const notificationData = [{
		icon: 'material-symbols-light:mark-email-unread-outline-sharp',
		title: 'New email received',
		desc: 'You have a new email from John Doe.',
		time: '2 minutes ago'
	}, {
		icon: 'material-symbols-light:calendar-clock-outline-sharp',
		title: 'Meeting reminder: Tomorrow at 9:00 AM',
		desc: 'Don\'t forget your meeting with the client.',
		time: '1 hour ago'
	}, {
		icon: 'material-symbols-light:checklist',
		title: 'Task completed',
		desc: 'The task assigned to you has been completed.',
		time: '4 hours ago'
	}, {
		icon: 'material-symbols-light:mark-unread-chat-alt-outline-sharp',
		title: 'New comment on your post',
		desc: 'Someone commented on your recent post.',
		time: '10 hours ago'
	}, {
		icon: 'material-symbols-light:update',
		title: 'System update scheduled',
		desc: 'There will be a system update tomorrow.',
		time: 'Yesterday at 6:00 PM'
	}];
	
	const toggleAppSidebarDesktop = () => {
		var elm = document.querySelector('.app');
		if (elm) {
			if (!(elm.classList.contains('app-with-top-nav') && elm.classList.contains('app-without-sidebar'))) {
				elm.classList.toggle('app-sidebar-collapsed');
				
				setTimeout(() => {
					window.dispatchEvent(new Event('resize'));
				}, 150);
			}
		}
	}
	
	const toggleAppSidebarMobile = () => {
		var elm = document.querySelector('.app');
		if (elm) {
			if (!(elm.classList.contains('app-with-top-nav') && elm.classList.contains('app-without-sidebar'))) {
				elm.classList.toggle('app-sidebar-mobile-toggled');
			} else {
				slideToggle(document.querySelector('.app-top-nav'));
			}
		}
	}
	
	const toggleAppHeaderSearch = () => {
		var elm = document.querySelector('.app');
		elm.classList.toggle('app-header-menu-search-toggled');
	}
	
	const toggleAppThemePanel = (event) => {
		event.preventDefault();
		
		var state = (appThemePanelToggled === 'true' || appThemePanelToggled === true) ? false : true;
		
		setAppThemePanelToggled(state);
		if (localStorage) {
			localStorage.setItem('appThemePanelToggled', state);
		}
	}

	return (
		<div id="header" className="app-header">
			<div className="desktop-toggler">
				<button type="button" className="menu-toggler" onClick={toggleAppSidebarDesktop}>
					<span className="bar"></span>
					<span className="bar"></span>
				</button>
			</div>
			
			<div className="mobile-toggler">
				<button type="button" className="menu-toggler" onClick={toggleAppSidebarMobile}>
					<span className="bar"></span>
					<span className="bar"></span>
				</button>
			</div>
			
			<div className="brand">
				<Link to="/" className="brand-logo w-100">
					<Icon icon="lets-icons:time-progress-duotone" className="fs-24px me-2 text-theme" />
					<span className="brand-text fw-500 fs-14px position-relative">
						QUANTUM
						<span className="text-nowrap" style={{ fontSize: '7px', letterSpacing: '1px', fontWeight: 'bold', position: 'absolute', opacity: '.5', top: '-7px', marginLeft: '-16px',}}>REACT 19.X</span>
					</span>
				</Link>
			</div>
			
			<div className="menu">
				<div className="menu-item dropdown d-lg-flex d-none">
					<a href="#/" className="menu-link">
						<span>$1,859,050.12</span>
					</a>
				</div>
				<div className="menu-item dropdown d-lg-flex d-none me-3">
					<div className="menu-search-inline">
						<span className="menu-icon"><Icon icon="ph:magnifying-glass-duotone" /></span>
						<input className="form-control" placeholder="Search something..." defaultValue="" name="keywords" />
					</div>
				</div>
				<div className="menu-item dropdown d-lg-none d-flex">
					<a href="#/" className="menu-link menu-link-icon" onClick={toggleAppHeaderSearch}>
						<Icon icon="ph:magnifying-glass-duotone" className="menu-icon" />
					</a>
				</div>
				
				<div className="menu-item dropdown">
					<a href="#/" className="menu-link menu-link-icon px-lg-3" data-bs-toggle="dropdown" data-bs-display="static">
						<Icon icon="ph:globe-duotone" className="menu-icon me-lg-2" />
						<span className="d-lg-flex d-none">EN</span>
					</a>
					<div className="dropdown-menu fade dropdown-menu-end mt-1 fs-10px text-uppercase">
						<a href="#/" className="dropdown-item d-flex align-items-center">English <span className="ms-auto fw-semibold text-white w-20px text-center">EN</span></a>
						<a href="#/" className="dropdown-item d-flex align-items-center">Spanish <span className="ms-auto fw-semibold text-white w-20px text-center">ES</span></a>
						<a href="#/" className="dropdown-item d-flex align-items-center">French <span className="ms-auto fw-semibold text-white w-20px text-center">FR</span></a>
						<a href="#/" className="dropdown-item d-flex align-items-center">German <span className="ms-auto fw-semibold text-white w-20px text-center">DE</span></a>
						<a href="#/" className="dropdown-item d-flex align-items-center">Italian <span className="ms-auto fw-semibold text-white w-20px text-center">IT</span></a>
						<a href="#/" className="dropdown-item d-flex align-items-center">Japanese <span className="ms-auto fw-semibold text-white w-20px text-center">JA</span></a>
						<a href="#/" className="dropdown-item d-flex align-items-center">Chinese <span className="ms-auto fw-semibold text-white w-20px text-center">ZH</span></a>
						<a href="#/" className="dropdown-item d-flex align-items-center">Russian <span className="ms-auto fw-semibold text-white w-20px text-center">RU</span></a>
					</div>
				</div>
				<div className="menu-item dropdown dropdown-mobile-full">
					<a href="#/" data-bs-toggle="dropdown" data-bs-display="static" className="menu-link menu-link-icon">
						<Icon icon="ph:calendar-dots-duotone" className="menu-icon" />
					</a>
					
					<div className="dropdown-menu dropdown-menu-end p-0 w-300px">
						<div className="card">
							{calendarData && calendarData.length > 0 ? (
								calendarData.map((calendar, calIndex) => (
									<React.Fragment key={calIndex}>
										<div className="card-header">{calendar.date}</div>
										{calendar.list && (
											<div className="card-body p-0 widget-reminder">
												{calendar.list.map((list, listIndex) => (
													<div className="widget-reminder-item" key={listIndex}>
														<div className="widget-reminder-time">
															{list.time_start && <div>{list.time_start}</div>}
															{list.time_end && <div>{list.time_end}</div>}
														</div>
														<div className={`widget-reminder-divider ${list.color}`}></div>
														<div className="widget-reminder-content">
															<div className="fw-semibold text-white">{list.title}</div>
															{list.desc && list.desc.map((desc, descIndex) => (
																<div key={descIndex}> - {desc}</div>
															))}
															{list.contact && list.contact.map((contact, contactIndex) => (
																<div className="d-flex align-items-center mt-2" key={contactIndex}>
																	<div className="flex-fill d-flex align-items-center">
																		{contact.img && (
																			<img src={contact.img} alt="" width="16" className="me-2" />
																		)}
																		{contact.name}
																	</div>
																	<Link to={contact.link} className="ms-auto">Contact</Link>
																</div>
															))}
														</div>
													</div>
												))}
											</div>
										)}
									</React.Fragment>
								))
							) : (
								<>
									<div className="card-header">TODAY</div>
									<div className="card-body fs-10px">No records found</div>
								</>
							)}
						</div>
						{calendarData && calendarData.length > 0 && (
							<Link className="dropdown-item fs-10px text-center py-2 d-block" to="/calendar">VIEW ALL</Link>
						)}
					</div>
				</div>
				<div className="menu-item dropdown dropdown-mobile-full">
					<a href="#/" data-bs-toggle="dropdown" data-bs-display="static" className="menu-link menu-link-icon">
						<Icon icon="ph:chats-duotone" className="menu-icon" />
					</a>
					<div className="dropdown-menu dropdown-menu-end fade p-0 w-300px">
						<div className="card">
							<div className="card-header with-btn">
								DISCUSSION GROUP
							</div>
		
							<PerfectScrollbar className={`card-body fs-10px ${chatData && chatData.length ? 'h-200px' : ''}`}>
								<div className="widget-chat">
									{chatData && chatData.length > 0 ? (
										chatData.map((chat, chatIndex) => (
											chat.date ? (
												<div className="widget-chat-date" key={chatIndex}>
													{chat.date}
												</div>
											) : (
												<div className={`widget-chat-item ${chat.reply ? 'reply' : ''}`} key={chatIndex}>
													{chat.img && (
														<div className="widget-chat-media">
															<img src={chat.img} alt="" />
														</div>
													)}
													<div className="widget-chat-content">
														{chat.name && <div className="widget-chat-name">{chat.name}</div>}
														{chat.msg && chat.msg.map((msg, msgIndex) => (
															<div
																className={`widget-chat-message ${msgIndex === chat.msg.length - 1 ? 'last' : ''}`}
																key={msgIndex}
															>
																{msg}
															</div>
														))}
													</div>
												</div>
											)
										))
									) : (
										<div className="widget-chat-item">
											No records found
										</div>
									)}
								</div>
							</PerfectScrollbar>
						</div>
		
						{chatData && chatData.length > 0 && (
							<Link className="dropdown-item fs-10px text-center py-2 d-block" to="/messenger">
								VIEW ALL
							</Link>
						)}
					</div>
				</div>
				
				<div className="menu-item dropdown dropdown-mobile-full">
					<a href="#/" data-bs-toggle="dropdown" data-bs-display="static" className="menu-link menu-link-icon">
						<Icon icon="ph:squares-four-duotone" className="menu-icon" />
					</a>
					<div className="dropdown-menu fade dropdown-menu-end p-0 w-300px text-center">
						<div className="row row-grid gx-0">
							<div className="col-4">
								<Link to="/email/inbox" className="dropdown-item text-decoration-none p-3 bg-none">
									<div className="position-relative">
										<i className="bi bi-circle-fill position-absolute text-theme top-0 mt-n2 me-n2 fs-6px d-block text-center w-100"></i>
										<i className="bi bi-envelope h2 opacity-5 d-block my-1"></i>
									</div>
									<div className="fw-500 fs-10px text-white">INBOX</div>
								</Link>
							</div>
							<div className="col-4">
								<Link to="/pos/customer-order" target="_blank" className="dropdown-item text-decoration-none p-3 bg-none">
									<div><i className="bi bi-hdd-network h2 opacity-5 d-block my-1"></i></div>
									<div className="fw-500 fs-10px text-white">POS SYSTEM</div>
								</Link>
							</div>
							<div className="col-4">
								<Link to="/calendar" className="dropdown-item text-decoration-none p-3 bg-none">
									<div><i className="bi bi-calendar4 h2 opacity-5 d-block my-1"></i></div>
									<div className="fw-500 fs-10px text-white">CALENDAR</div>
								</Link>
							</div>
						</div>
						<div className="row row-grid gx-0">
							<div className="col-4">
								<Link to="/helper" className="dropdown-item text-decoration-none p-3 bg-none">
									<div><i className="bi bi-terminal h2 opacity-5 d-block my-1"></i></div>
									<div className="fw-500 fs-10px text-white">HELPER</div>
								</Link>
							</div>
							<div className="col-4">
								<Link to="/settings" className="dropdown-item text-decoration-none p-3 bg-none">
									<div className="position-relative">
										<i className="bi bi-circle-fill position-absolute text-theme top-0 mt-n2 me-n2 fs-6px d-block text-center w-100"></i>
										<i className="bi bi-sliders h2 opacity-5 d-block my-1"></i>
									</div>
									<div className="fw-500 fs-10px text-white">SETTINGS</div>
								</Link>
							</div>
							<div className="col-4">
								<Link to="/widgets" className="dropdown-item text-decoration-none p-3 bg-none">
									<div><i className="bi bi-collection-play h2 opacity-5 d-block my-1"></i></div>
									<div className="fw-500 fs-10px text-white">WIDGETS</div>
								</Link>
							</div>
						</div>
					</div>
				</div>
				
				<div className="menu-item dropdown dropdown-mobile-full">
					<a href="#/" data-bs-toggle="dropdown" data-bs-display="static" className="menu-link menu-link-icon">
						<Icon icon="ph:warning-duotone" className="menu-icon" />
					</a>
					<div className="dropdown-menu dropdown-menu-end fade w-300px p-0">
						<h6 className="dropdown-header fw-semibold py-2">NOTIFICATIONS</h6>
						{notificationData && notificationData.length > 0 ? (
							<>
								{notificationData.map((notification, index) => (
									<a href="#/" key={index} className="dropdown-item d-flex align-items-center fs-10px">
										<div>
											<div className="w-40px h-40px bg-white bg-opacity-10 text-white fs-30px d-flex align-items-center justify-content-center">
												<Icon icon={notification.icon} />
											</div>
										</div>
										<div className="flex-1 ps-3 text-truncate">
											<div className="text-white fw-semibold">{notification.title}</div>
											<div className="text-white text-opacity-75">{notification.desc}</div>
											<div className="text-white text-opacity-50 small">{notification.time}</div>
										</div>
									</a>
								))}
								<Link className="dropdown-item fs-10px text-center py-2 d-block" to="/messenger">
									VIEW ALL
								</Link>
							</>
						) : (
							<div className="small p-3 bg-white bg-opacity-15">No records found</div>
						)}
					</div>
				</div>
				
				<div className="menu-item dropdown">
					<a href="#/" onClick={toggleAppThemePanel} className="menu-link menu-link-icon">
						<Icon icon="ph:gear-duotone" className="menu-icon" />
					</a>
				</div>
				<div className="menu-item dropdown dropdown-mobile-full">
					<a href="#/" data-bs-toggle="dropdown" data-bs-display="static" className="menu-link d-flex align-items-center">
						<div className="menu-img online me-sm-2 ms-lg-0 ms-n2">
							{userData.img ? (
								<img src={userData.img} alt="Profile" className="" />
							) : (
								<div className="d-flex align-items-center justify-content-center w-100 h-100 bg-white bg-opacity-25 text-white text-opacity-50 rounded-circle overflow-hidden">
									<i className="bi bi-person-fill fs-24px mb-n3"></i>
								</div>
							)}
						</div>
						<div className="menu-text d-sm-block d-none">
							<span className="d-block">
								<span>{userData.name}</span>
							</span>
						</div>
					</a>
					<div className="dropdown-menu dropdown-menu-end me-lg-3 fs-10px fade">
						<h6 className="dropdown-header">USER OPTIONS</h6>
						<Link className="dropdown-item" to="/profile">VIEW PROFILE</Link>
						<Link className="dropdown-item" to="/settings">ACCOUNT SETTINGS</Link>
						<Link className="dropdown-item" to="/calendar">CALENDER SETTINGS</Link>
						<div className="dropdown-divider"></div>
						<Link className="dropdown-item" to="/helper">HELP & SUPPORT</Link>
						<Link className="dropdown-item" to="/page/login">LOG OUT</Link>
					</div>
				</div>
			</div>
			
			<form className="menu-search-float" name="header_search_form">
				<div className="menu-search-container">
					<div className="menu-search-icon"><i className="bi bi-search"></i></div>
					<div className="menu-search-input">
						<input type="text" className="form-control" defaultValue="" placeholder="Search something..." />
					</div>
					<div className="menu-search-icon">
						<a href="#/" onClick={toggleAppHeaderSearch}><i className="bi bi-x-lg"></i></a>
					</div>
				</div>
			</form>
		</div>
	)
}

export default Header;
